import React from 'react'
import Script from 'next/script'
import { AppProviders } from '../context/index'
import { GlobalStyle } from '../styles/globals.style.js'
import AnalyticsTracker from '../components/analytics-tracker/analytics-tracker.component.jsx'
import { GA_MEASUREMENT_ID } from '../lib/analytics'
import { CookieConsentComp } from '../components/cookie-concent/cookie-concent.component.jsx'

function MyApp({ Component, pageProps, router }) {
  return (
    <AppProviders>
      {/* Analytics and Clarity scripts */}
      <Script
        src={`https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`}
        strategy="afterInteractive"
      />
      <Script id="gtag-init" strategy="afterInteractive">
        {`
          window.dataLayer = window.dataLayer || [];
          function gtag() { dataLayer.push(arguments); }
          gtag('consent', 'default', {
            'ad_storage': 'denied',
            'ad_user_data': 'denied',
            'ad_personalization': 'denied',
            'analytics_storage': 'denied'
          });
          gtag('js', new Date());
          gtag('config', '${GA_MEASUREMENT_ID}', { 'send_page_view': false });
        `}
      </Script>
      <AnalyticsTracker pageProps={pageProps} />
      <CookieConsentComp />
      {/* <Script id="clarity-init" strategy="afterInteractive">
        {`
          (function(c,l,a,r,i,t,y){
              c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
              t=l.createElement(r);t.defer=1;t.src="https://www.clarity.ms/tag/"+i;
              y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
          })(window, document, "clarity", "script", "lmxygneuzp");
        `}
      </Script> */}
      <Component {...pageProps} />
      <GlobalStyle />
    </AppProviders>
  )
}

export default MyApp
